import React from 'react';

const CardShimmer = () => (
  <div className="card-shimmer">
    <div className="card-shimmer_group">
      <div className="skeleton" />
      <div className="skeleton" />
    </div>
    <div className="card-shimmer_simple skeleton" />
    <div className="card-shimmer_group">
      <div className="skeleton" />
      <div className="skeleton" />
      <div className="skeleton" />
    </div>
    <div className="card-shimmer_group-wrap">
      <div className="card-shimmer_simple skeleton" />
      <div className="card-shimmer_group">
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
      <div className="card-shimmer_group">
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
      <div className="card-shimmer_group">
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
    </div>
    <div className="card-shimmer_group-wrap">
      <div className="card-shimmer_simple skeleton" />
      <div className="card-shimmer_group">
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
      <div className="card-shimmer_group">
        <div className="skeleton" />
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
      <div className="card-shimmer_group">
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
    </div>
  </div>
);

export default CardShimmer;
